import React, { useState } from 'react';
import { Checkbox } from "@progress/kendo-react-inputs";

export const CheckboxFilterCell = (props, label) => {
  const [value, setValue] = useState(false);

  const onChange = (event) => {
    const checked = event.target.value
    setValue(checked);

    props.onChange({
      value: checked ? 1 : 0,
      operator: "gte",
      syntheticEvent: event.syntheticEvent,
    });
  };

  return (
    <div className="k-filtercell">
      <Checkbox
        aria-label={props.label}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};